import { COLORS } from 'assets/styled';
import styled from 'styled-components';

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  cursor: grab;
  color: ${COLORS.GRAY_300};

  &:active {
    cursor: grabbing;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20rem;
  color: ${COLORS.BLACK};
  font-size: 14rem;
  border: 1rem dashed ${COLORS.BORDER};
  border-radius: 8rem;
`;

export const IconButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const InlineButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8rem;
  width: 100%;
`;

export const PriceText = styled.span`
  color: ${COLORS.BLACK};
  font-size: 13rem;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10rem;
  width: 100%;
  padding: 10rem 12rem;
  border: 1rem solid ${COLORS.BORDER};
  border-radius: 8rem;
  background-color: ${COLORS.WHITE};
`;

export const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12rem;
`;

export const RowLabel = styled.label`
  color: ${COLORS.BLACK};
  font-size: 15rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RowMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  flex: 1;
  min-width: 0;
`;

export const RowSubInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8rem;
  flex-wrap: wrap;
`;

export const SlugBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2rem 8rem;
  border-radius: 12rem;
  background-color: ${COLORS.GRAY_300};
  color: ${COLORS.BLACK};
  font-size: 12rem;
  font-family: monospace;
`;

export const ToggleCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5rem;
`;

export const ToggleLabel = styled.span`
  color: ${COLORS.BLACK};
  font-size: 14rem;
`;
